import { Pipe, PipeTransform } from '@angular/core';
import { ObservationsAndRecommandationsPluginService } from './observationsandrecommandations-plugin.service';

@Pipe({
    name: 'responsiblespipe',
    standalone: false
})
export class ResponsiblesPipe implements PipeTransform {
  public responsibles: any;

  constructor(private service: ObservationsAndRecommandationsPluginService) {
    this.responsibles = this.service.getResponsibles();
  }

  transform(id: string): any {
    return this.service.getValue(parseInt(id), this.responsibles);
  }
}
